module.exports = __webpack_public_path__ + "img/egg-poultry.3e00bf43.png";